const Message = ({
  className,
  children,
  id,
  onDismissMessagePanel,
  marginLeft,
  marginBottom,
  marginTop
}) => (
  <div id={id} className={className + ' message-container'}>
    <span className="messageLabel">
      {onDismissMessagePanel ? (
        <i onClick={onDismissMessagePanel} className="far fa-times message_dismiss_cross" />
      ) : null}
      {children}
    </span>

    <style jsx="true">{`
      .message-container {
        margin-top: ${marginTop ? marginTop : '39px'};
        margin-bottom: ${marginBottom ? marginBottom : '10px'};
      }

      .messageLabel {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 1em;
        margin-inline-end: 1em;

        border-radius: 2px;
        background-color: #edf6f3;
        margin: auto;
        max-width: 512px;
        padding: 12px;
        margin-left: ${marginLeft};
      }
      .message_dismiss_cross {
        float: right;
      }
    `}</style>
  </div>
);

export default Message;
